module.exports = __webpack_public_path__ + "static/media/gb-eng.bc94e946.svg";